import { defineStore } from 'pinia';
import { isFeatureEnabled } from '@utils/featureFlags.js';

/**
 * Language field descriptions:
 * {
 *      label: User friendly label.
 *      value: This is the language key as used by the backend. (fr-fr is from Django)
 *      isoName: This is the language key sa used by the Quasar language pack. (fr is from Quasar)
 *      See Quasar's Language Pack documentation for key names + languages supported.
 * }
 */
const BASE_LANGUAGES = [
    {
        label: 'English (US)',
        value: 'en-us',
        isoName: 'en-US'
    },
    {
        label: 'Français',
        value: 'fr-fr',
        isoName: 'fr'
    },
    {
        label: 'Español',
        value: 'es',
        isoName: 'es'
    }
];

const PORTUGUESE_LANGUAGE = {
    label: 'Português (BR)',
    value: 'pt-br',
    isoName: 'pt-BR'
};

export const useLanguagesStore = defineStore('languages', {
    state: () => ({
        languages: []
    }),

    getters: {
        /**
         * Gets the cached available languages.
         * @returns {Object[]|null} Array of available language objects or null if not loaded.
         */
        getLanguages: state => state.languages
    },

    actions: {
        /**
         * Resets the state to its default values.
         */
        resetState() {
            this.$reset();
        },
        /**
         * Loads and stores available languages based on feature flags.
         * @returns {Object[]} Array of available language objects.
         */
        async loadLanguagesAction() {
            const languages = [...BASE_LANGUAGES];

            try {
                // Add Portuguese only if the feature flag is enabled
                if (await isFeatureEnabled('PORTUGUESE_LANGUAGE')) {
                    languages.push(PORTUGUESE_LANGUAGE);
                }
            } catch (error) {
                // If feature flags aren't available yet, just use base languages
                console.warn(
                    'Feature flags not available, using base languages only'
                );
            }

            // Cache the languages
            this.languages = languages;

            return languages;
        }
    }
});
